import {
  API_REQUEST_END,
  API_REQUEST_START,
  CLEAR_ALL_STATE,
  CLEAR_NEW_CONTACT_FORM,
  CLEAR_POLICY_INFO_FORM,
  FOUND_USERNAME,
  OTP_ERROR,
  OTP_VERIFIED,
  POLICY_INFO_FORM_SUBMITTED,
  SELECTED_POLICY,
  SET_FIND_MY_POLICY_CONFIG,
  SET_NEW_CONTACT_LIFE,
  SET_NEW_CONTACT_NON_LIFE,
  SET_NEW_PASSWORD,
} from '@services/actions';
import { initialStore, PKG_NAME, ScopedStore } from '@services/store';

const scopedRootReducer = (
  state: ScopedStore = initialStore,
  action,
): ScopedStore => {
  switch (action.type) {
    case CLEAR_ALL_STATE:
      return initialStore;
    case SET_FIND_MY_POLICY_CONFIG:
      return {
        ...state,
        findMyPolicyConfig: action.payload,
      };
    case CLEAR_POLICY_INFO_FORM:
      return {
        ...state,
        policyInfoForm: undefined,
      };
    case CLEAR_NEW_CONTACT_FORM:
      return {
        ...state,
        newUsernameForm: undefined,
      };
    case OTP_VERIFIED:
      return {
        ...state,
        otpPayload: action.payload.otp,
      };
    case OTP_ERROR:
      return {
        ...state,
        otpErrorMessage: action.payload.otpErrorMessage,
      };
    case SELECTED_POLICY:
      return {
        ...state,
        selectedPolicy: action.payload.selectedPolicy,
      };
    case POLICY_INFO_FORM_SUBMITTED:
      return {
        ...state,
        policyInfoForm: action.payload.policyInfoForm,
      };
    case FOUND_USERNAME:
      return {
        ...state,
        foundUserNames: action.payload.foundUserNames,
      };
    case SET_NEW_CONTACT_NON_LIFE:
      return {
        ...state,
        newUsernameForm: {
          ...state.newUsernameForm,
          selectType: 'freeText',
          policyType: action.payload.policyType,
          ...action.payload.newContactObj,
        },
      };
    case SET_NEW_CONTACT_LIFE:
      return {
        ...state,
        newUsernameForm: {
          ...state.newUsernameForm,
          selectType: 'select',
          policyType: action.payload.policyType,
          ...action.payload.newContactObj,
        },
      };
    case SET_NEW_PASSWORD:
      return {
        ...state,
        newUsernameForm: {
          ...state.newUsernameForm,
          password: action.payload.password,
        },
      };
    case API_REQUEST_START:
      return {
        ...state,
        isApiLoading: true,
      };
    case API_REQUEST_END:
      return {
        ...state,
        isApiLoading: false,
      };
    default:
      return { ...state };
  }
};

const scopedReducers = {
  [PKG_NAME]: scopedRootReducer,
};

export default scopedReducers;
